import React, { useState } from 'react';
import { Table, Dropdown, Menu, Button, Space, Typography } from 'antd';
import { EyeOutlined, FlagOutlined, CheckOutlined, DownOutlined } from '@ant-design/icons';
import './ViewListProvider.css';

const { Title } = Typography;

const ViewListProvider = () => {
  // Sample data for service providers
  const dataSource = [
    { key: '1', name: 'Dave County services', zip: '94052', status: 'Active', category: 'Wellness', ip: '192.00.22' },
    { key: '2', name: 'Bush County services', zip: '97431', status: 'Pending Approval', category: 'Housing', ip: '192.00.22' },
    { key: '3', name: 'Bush County services', zip: '97431', status: 'Flagged', category: 'Housing', ip: '192.00.22' },
  ];

  // Define columns
  const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'ZIP', dataIndex: 'zip', key: 'zip' },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (status) => (
      <span className={status === 'Active' ? 'status-active' : status === 'Flagged' ? 'status-flagged' : 'status-pending'}>{status}</span>
    )},
    { title: 'Category', dataIndex: 'category', key: 'category' },
    { title: 'Last IP Address', dataIndex: 'ip', key: 'ip' },
    { 
      title: 'Action', 
      key: 'action', 
      render: (_, record) => (
        <Space size="middle">
          <Dropdown overlay={menu(record)} trigger={['click']}>
            <Button icon={<DownOutlined />} size="small">
              Actions
            </Button>
          </Dropdown>
        </Space>
      ),
    },
  ];

  // Menu for dropdown actions
  const menu = (record) => (
    <Menu>
      <Menu.Item key="1" icon={<EyeOutlined />} onClick={() => handleView(record)}>
        View
      </Menu.Item>
      <Menu.Item key="2" icon={<FlagOutlined />} onClick={() => handleFlag(record)}>
        Flag
      </Menu.Item>
      <Menu.Item key="3" icon={<CheckOutlined />} onClick={() => handleApprove(record)}>
        Approve
      </Menu.Item>
    </Menu>
  );

  // Placeholder functions for actions
  const handleView = (record) => {
    console.log('View:', record);
  };

  const handleFlag = (record) => {
    console.log('Flag:', record);
  };

  const handleApprove = (record) => {
    console.log('Approve:', record);
  };

  return (
    <div className="view-list-provider-container">
      <Title level={3} className="view-list-provider-title">Service Providers</Title>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={{ pageSize: 5 }}
        className="view-list-provider-table"
      />
    </div>
  );
};

export default ViewListProvider;